<template>
  <b-input-group class="login-password-form-field">
    <nx-bform-input
      :name="defaultName"
      :rules="{ required: required }"
      :type="type"
      :value="$attrs.value"
      @input="$listeners.input"
      :aria-label="name"
    />
    <template #append>
      <b-button class="eye" :pressed="toggle" @click="toggleView" aria-label="View password">
        <i class="far fa-eye-slash"></i>
      </b-button>
    </template>
  </b-input-group>
</template>

<script>
import FormFieldMixin from "../form-field.mixin";

export default {
  mixins: [FormFieldMixin],
  data() {
    return {
      type: "password",
      toggle: false,
    };
  },
  computed: {
    defaultName() {
      return this.name || this.$t("password");
    },
  },
  methods: {
    toggleView() {
      if (this.toggle) {
        this.type = "password";
        this.toggle = false;
      } else {
        this.type = "text";
        this.toggle = true;
      }
    },
  },
};
</script>

<i18n src="@/locales/login.locale.json" />
